import { createWebSocketStore } from 'src/components/#services/helpers';
import { api } from 'src/services/api/reallis';
export const getStakingInfo = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'staking',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'staking_getStartDateAndEndDate',
    },
});
export const stake = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'staking',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'stakingBalance_addTokensInStaking',
    },
});
export const cancelStake = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'staking',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'stakingBalance_cancelStaking',
    },
});
export const getStakingBalance = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'staking',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'stakingBalance_getStakingBalanceIfUserExist',
    },
});
export const getStakingTransactions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'transactions',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'registryTransaction_getStakingTransactionsByUserId',
    },
});
export const getStakingTotalAmount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'staking',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'stakingBalance_getTotalStakingLisAmount',
    },
});
// region init
api.ws.ws1.auth.on('login', () => {
    getStakingBalance.send();
});
// endregion
